/** Token-aware HTTP client for the admin API — delegates to the genapi generated client. */
import {
  createClient,
  getApiToken,
  setApiToken,
} from '../../../gen/client/react'

// Re-export the generated token holder so AuthContext and any future callers
// import from a single canonical location.
export { setApiToken, getApiToken }

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

// Module-level singleton: bearer token and fetch are both resolved lazily at
// request time so tests can set up global.fetch per-test and so auth-context
// token changes are picked up without recreating the client.
// The generated client auto-attaches credentials:'same-origin' and
// X-CSRF-Token on unsafe methods.
export const client = createClient({
  baseUrl: window.location.origin,
  bearerToken: () => getApiToken(),
  // Wrap fetch lazily so the constructor never evaluates the bare `fetch`
  // identifier at module-load time. jsdom tests set up global.fetch per-test,
  // not at import time; without this, ApicClient's constructor fails.
  fetchImpl: (input, init) => fetch(input, init),
})
